// First script to modify Vimeo links
jQuery(document).ready(function ($) {
	if (!document.body.classList.contains('wp-admin')) {
		document
			.querySelectorAll('main a[href*="vimeo"]')
			.forEach(function (link) {
				link.setAttribute('data-video-id', link.href.split('/').pop());
				link.removeAttribute('href');
				link.classList.add('open-video-modal');
			});

		// Second script to handle the modal functionality
		document.querySelectorAll('.open-video-modal').forEach(function (link) {
			link.addEventListener('click', function (event) {
				event.preventDefault();
				var videoId = this.getAttribute('data-video-id');
				var videoSrc = `https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0`;
				document.getElementById('vimeo-video').src = videoSrc;
				document.getElementById('video-modal').style.display = 'flex';
			});
		});

		document
			.querySelector('#video-modal .close')
			.addEventListener('click', function () {
				document.getElementById('video-modal').style.display = 'none';
				document.getElementById('vimeo-video').src = ''; // Stop the video
			});

		document
			.getElementById('video-modal')
			.addEventListener('click', function (event) {
				if (event.target === this) {
					document.getElementById('video-modal').style.display =
						'none';
					document.getElementById('vimeo-video').src = ''; // Stop the video
				}
			});
	}
});

// Now we want to do the same but we're looking for links with /form=[number] in the href, then load the form-modal and populate it with the gravity form using the Gravity Form Rest API
// First script to modify Gravity Form links
jQuery(document).ready(function ($) {
	if (!document.body.classList.contains('wp-admin')) {
		document.querySelectorAll('a[href*="form="]').forEach(function (link) {
			var formId = link.href.split('/form=').pop();
			link.setAttribute('data-form-id', formId);
			link.removeAttribute('href');
			link.classList.add('open-form-modal');
		});

		document.querySelectorAll('.open-form-modal').forEach(function (link) {
			link.addEventListener('click', function (event) {
				event.preventDefault();
				var formId = this.getAttribute('data-form-id');

				document.getElementById('form-modal').style.display = 'flex'; // Display the modal

				$.ajax({
					type: 'POST',
					url: '/wp-admin/admin-ajax.php',
					data: {
						action: 'load_gravity_form',
						form_id: formId,
					},
					success: function (response) {
						document.querySelector(
							'#form-modal #form-content'
						).innerHTML = response;
					},
					error: function (error) {
						console.error('Error loading form:', error);
						document.querySelector(
							'#form-modal #form-content'
						).innerHTML =
							'<p>There was an error loading the form. Please try again later.</p>';
					},
				});
			});
		});

		document
			.querySelector('#form-modal .close')
			.addEventListener('click', function () {
				document.getElementById('form-modal').style.display = 'none';
				document.querySelector('#form-modal #form-content').innerHTML =
					'';
			});

		document
			.getElementById('form-modal')
			.addEventListener('click', function (event) {
				if (event.target === this) {
					document.getElementById('form-modal').style.display =
						'none';
					document.querySelector(
						'#form-modal #form-content'
					).innerHTML = '';
				}
			});
	}
});

// Customization of the Date Picker
jQuery(document).ready(function ($) {
	gform.addFilter(
		'gform_datepicker_options_pre_init',
		function (optionsObj, formId, fieldId) {
			// Get the field element
			var fieldElement = $('#field_' + formId + '_' + fieldId);

			// Check if the field has a specific class (replace 'future-dates-only' with your desired class)
			if (fieldElement.hasClass('future')) {
				optionsObj.minDate = 0; // Disables past dates, allowing only today and future dates
			}
			return optionsObj;
		}
	);
});
